import { useState, useTransition } from "react";
import { getPaymentContext } from "@/clientSideApi/core";
import { toast } from "react-toastify";

let cashfree;
let modalChanged;

const useCashfree = ({
    token,
    onPaymentSuccess,
    setPaymentModal,
}) => {

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [isPending, startTransition] = useTransition();

    const success = function (data, order_token, prepayment_percentage) {
        setPaymentModal(false);
        toast.success(`Amount Successfully paid for order id: ${data.order.orderId}`, {
            position: "top-right",
            autoClose: 2500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
        if (onPaymentSuccess) onPaymentSuccess({order_token, prepayment_percentage});
    };

    const failure = function (data) {
        setPaymentModal(false);
        toast.info(data.order.errorText || "Payment Failed!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    };

    const handlePaymentClick = (token, prepayment_percentage) => {
        startTransition(() => setPaymentModal(true));
        modalChanged = setInterval(function () {
            if (isPending === false) {
                const paymentDom = document.getElementById("cash-free-ornaz");
                if (!paymentDom) return;
                clearInterval(modalChanged);
                cashfree = new window.Cashfree();
                const dropConfig = {
                    components: [
                        "order-details",
                        "card",
                        "upi",
                        "app",
                        "netbanking",
                        "paylater",
                        "credicardemi",
                        "cardlessemi",
                    ],
                    orderToken: token,
                    onSuccess: (data) => success(data, token, prepayment_percentage),
                    onFailure: failure,
                    style: {
                        backgroundColor: "transparent",
                        color: "#45d4d5",
                        fontFamily: "Roboto",
                        fontSize: "14px",
                        errorColor: "#ff0000",
                        theme: "light", //(or dark)
                    },
                };
                cashfree.initialiseDropin(paymentDom, dropConfig);
            }
        }, 10);
    };

    const handlePaymentContext = async (token, prepayment_percentage) => {
        if (loading) return;
        setLoading(true);
        setError(false);
        const { result, error } = await getPaymentContext(token);
        setLoading(false);
        if (error) {
            setError(error);
            setPaymentModal(false);
            return;
        }
        setData(result);
        if (result.if_full_paid) {
            toast.success("You have already paid for this order. Thankyou!", {
                position: "top-right",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            return;
        }
        handlePaymentClick(token, prepayment_percentage);
    };

    const handleCashFreeModal = (prepayment_percentage=100, immediateCtx) => {
        const currentToken = token || data?.cash_free_order_token || immediateCtx?.order_token;
        const currentData = data || immediateCtx;
        if (!currentToken) return
        if (currentData && !error) {
            if (!currentData.if_full_paid) {
                handlePaymentClick(currentData.cash_free_order_token, prepayment_percentage);
            }else{
                toast.success("You have already paid for this order. Thankyou!", {
                    position: "top-right",
                    autoClose: 2500,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setPaymentModal(false);
                if (onPaymentSuccess) onPaymentSuccess({
                    order_token: data.cash_free_order_token, 
                    prepayment_percentage
                });
            }
        } else {
            handlePaymentContext(token, prepayment_percentage);
        }
    }

    return {
        handleCashFreeModal,
        loading
    }
};

export default useCashfree;
